import React, { useState, useEffect } from "react";
import moment from "moment";
import { DayPickerSingleDateController } from "react-dates";
import { useStateValue } from "../../state/context";
import StepControlls from "./generic/StepControlls";
import BreadCrumb from "./generic/BreadCrumb";
import ButtonEmpty from "../button/ButtonEmpty";

import "../../styles/job/service-date.css";

export default function ServiceAvailability(props) {
    const [{ job }, dispatch] = useStateValue();

    const [focused, setFocused] = useState(true);

    const clearDate = () => {
        dispatch({
            type: "JOB_AVAILABILITY",
            dateTo: null,
            buttonTitle: "Continuar sin fecha"
        });
    };

    const onDateChangeDate = date => {
        dispatch({
            type: "JOB_AVAILABILITY",
            dateTo: date.utc().startOf("day"),
            buttonTitle: "Continuar"
        });
    };

    useEffect(() => {
        if (!(props.location.state && "inner" in props.location.state))
            props.history.replace("/job/new");
    }, []);

    const RenderDate = () => {
        return (
            <DayPickerSingleDateController
                onDateChange={onDateChangeDate}
                onFocusChange={() => setFocused(true)}
                focused={focused}
                date={job.availability.dateTo}
                numberOfMonths={2}
                hideKeyboardShortcutsPanel={true}
                isOutsideRange={date => job.price.selectedOption === "urgent" ? (date.isAfter(moment().add(1, "days").endOf("day")) || date.isBefore(moment().startOf("day"))) : date.isBefore(moment().add(1, "days").endOf("day"))}
            />
        );
    };

    return (
        <div id="service-date" className="section">
            <BreadCrumb history={props.history} location={props.location} />
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <h4 className="title">Fecha del servicio</h4>
                        <p>Fijar fecha de visita</p>
                        <div className="content">
                            <RenderDate />
                            {job.availability.dateTo && (
                                <ButtonEmpty
                                    buttonText="Limpiar fecha"
                                    onClick={clearDate}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <StepControlls
                page={props.step}
                next="job/new/description"
                prev="job/new/price"
                nextTitle={job.availability.buttonTitle}
            />
        </div>
    );
}
